import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlourescentIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flourescent"}/>
}
